module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += 'Upload your images easily by selecting one or more from the desktop and dragging them to the Image Widget or directly to the Scene.';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/common/tip/ImageUploadTip.tpl
// module id = 3189
// module chunks = 0